export enum SSN_OPTION_ENUM {
  HIDE = '1',
  SHOW = '2',
}
export const SSN_MODAL_MESSAGE = 'Choose how to display Social Security Numbers:';
export const SSN_MODAL_OPTION = [
  { value: SSN_OPTION_ENUM.HIDE, label: 'Hide' },
  { value: SSN_OPTION_ENUM.SHOW, label: 'Show' },
];
